import React, { useEffect, useState } from "react";
import { Country } from "country-state-city";
import axios from "axios";
import { Input, Select, Button, message, Table, Row, Col, Form } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  setCompanyName,
  setSupplierId,
  setUserType,
  setCountryCode,
  setFilteredData,
  setReported,
  setGoalsSubmitted,
} from "../../redux/slices/supplierSearchSlice";
import {
  BASE_URL,
  SUPPLIER_SEARCH_FILTER,
  SUPPLIER_SEARCH_COLUMNS,
  TEXT_CONSTANTS,
  SUPPLIER_SEARCH_EXCEL_COLUMNS,
} from "../../constants/Constants";
import { downloadExcel } from "../../util/excelUtils";

import { API_ENDPOINTS } from "../../constants/apiConstant";
import "./Supplier.css";
import { DownloadOutlined } from "@ant-design/icons";

const { Option } = Select;

const SupplierSearch = () => {
  const [pagePermission, setPagePermission] = useState({});
  

  useEffect(() => {
    const permission = sessionStorage.getItem('UserPermission');
    console.log( permission);
    
      const parsedPermissions = JSON.parse(permission);
      console.log(parsedPermissions);
      
      setPagePermission(parsedPermissions);

  }, []);
  const dispatch = useDispatch();
  const {
    companyName,
    supplierId,
    userType,
    countryCode,
    reported,
    goalsSubmitted,
    filteredData,
  } = useSelector((state) => state.supplierSearch);

  const [companyNameError, setCompanyNameError] = useState("");
  const supplierTypeOptions = ["Supplier", "Seller"];
  const [countryOptions, setCountryOptions] = useState([]);
  const [excelDownloadButtonEnable, setExcelDownloadButtonEnable] =
    useState(false);
  const reportedOptions = ["Submitted", "In progress"];
  const goalsOption = ["Active", "Archived"];

  useEffect(() => {
    const countries = Country.getAllCountries().map((country) => ({
      value: country.isoCode,
      label: country.name,
    }));
    setCountryOptions(countries);
  }, []);

  const handleInputChange = (e) => {
    const value = e.target.value;
    const disallowedChars = /[?*<>:;'"|%[\]{}\\/]/;

    if (/^\d+$/.test(value)) {
      setCompanyNameError("Only numbers are not allowed.");
    } else if (disallowedChars.test(value)) {
      setCompanyNameError(
        "?, *, <, >, :, ;, ', \", |, %, [, ], {, }, /, or \\. are not allowed "
      );
    } else if (/^[^a-zA-Z0-9]+$/.test(value)) {
      setCompanyNameError("Only special characters are not allowed.");
    } else {
      setCompanyNameError("");
    }

    if (value.length > 30) {
      setCompanyNameError("Only 30 characters allowed.");
      dispatch(setCompanyName(value.slice(0, 30)));
      return;
    }

    dispatch(setCompanyName(value));
  };

  const handleSupplierIdChange = (e) => {
    const value = e.target.value;
    if (/^\d{0,6}$/.test(value)) {
      dispatch(setSupplierId(value));
    }
  };


  async function handleApplyFilter() {
    message.destroy();
    if (
      !companyName.trim() &&
      !supplierId.trim() &&
      !userType &&
      !countryCode &&
      !reported &&
      !goalsSubmitted
    ) {
      message.error(
        "Please enter at least one filter criterion before applying filter."
      );
      return;
    }

    if (companyNameError || supplierId.length > 6) {
      message.error("Please check the input.");
      return;
    }
    dispatch(setFilteredData([]));
    const filterRequest = {
      ...(companyName && { companyName }),
      ...(supplierId && { supplierId }),
      ...(userType && { supplierType: userType }),
      ...(countryCode && { countryCode }),
      ...(reported && { reported }),
      ...(goalsSubmitted && { goals: goalsSubmitted }),
    };

    const filterString = Object.keys(filterRequest)
      .map(
        (key) =>
          encodeURIComponent(key) + "=" + encodeURIComponent(filterRequest[key])
      )
      .join("&");

    try {
      const response = await axios.get(
        `${API_ENDPOINTS.BASE_URL}${SUPPLIER_SEARCH_FILTER}?${filterString}`,{
          headers:{
            Authorization: `Bearer ${sessionStorage.getItem("authToken")}`
          }
        }
      );

      if (response.data.length > 0) {
        dispatch(setFilteredData(response.data));
        message.success("Filter applied successfully");
      } else {
        dispatch(setFilteredData([]));
        message.warning("No suppliers found");
      }
    } catch (error) {
      console.error("Error fetching supplier data:", error);
      dispatch(setFilteredData([]));
      message.error("Failed to apply filter. Please try again.");
    }
  }

  const handleCancelFilter = () => {
    dispatch(setCompanyName(""));
    dispatch(setCountryCode(""));
    dispatch(setUserType(""));
    dispatch(setSupplierId(""));
    dispatch(setReported(""));
    dispatch(setGoalsSubmitted(""));
    // Clear the error message when canceling
    setCompanyNameError("");
    dispatch(setFilteredData([]));
  };
  useEffect(() => {
    return () => {
      handleCancelFilter();
    };
  }, []);
  const downloadExcelWithThrottle = (func, delay) => {
    let timer = null;
    setExcelDownloadButtonEnable(true);
    return () => {
      if (!timer) {
        func();
        timer = setTimeout(() => {
          timer = null;
          setExcelDownloadButtonEnable(false);
        }, delay);
      }
    };
  };
  const handleDownloadExcel = () => {
    if(pagePermission["SUPPLIER_SEARCH_DOWNLOAD"]){
    const finishDownload = downloadExcelWithThrottle(() => {
      const dataForExcel = filteredData.map((supplier) => {
        return {
          [SUPPLIER_SEARCH_EXCEL_COLUMNS[0]]: supplier.companyName || "UST",
          [SUPPLIER_SEARCH_EXCEL_COLUMNS[1]]: supplier.supplierId,
          [SUPPLIER_SEARCH_EXCEL_COLUMNS[2]]: supplier.totalEmissions,
          [SUPPLIER_SEARCH_EXCEL_COLUMNS[3]]: supplier.emissionSaved,
          [SUPPLIER_SEARCH_EXCEL_COLUMNS[4]]: supplier.recyclePackaging,
          [SUPPLIER_SEARCH_EXCEL_COLUMNS[5]]: supplier.activeGoalsCount,
        };
      });
      downloadExcel(dataForExcel, "Suppliers");
    }, 1000);
    finishDownload();
  }else{
    message.warning("You do not have Access")
  }
  };

  if(pagePermission["SUPPLIER_SEARCH"]===false){
    return <div>You do not have permission to access the SUPPLIER SEARCH.</div>;
  }


  return (
    <>
      <div className="text-[#2C5778] m-auto flex justify-center mb-4 text-2xl font-semibold">
        <span>Supplier Search</span>
      </div>
      <div
        className="bg-white rounded-md border-2 border-[#2C57785C] shadow-md m-auto p-6 w-[65%]"
        data-testid="supplier-search-form-container"
      >
        <Form
          layout="horizontal"
          className="max-w-full"
          data-testid="supplier-search-form"
        >
          <Row gutter={16} justify="start">
            <Col span={12} xs={24} sm={24} md={12} lg={12} xl={12}>
              <div
                className="form-item-content-supplier"
                style={
                  companyNameError
                    ? { minHeight: "90px", marginTop: "-14px" }
                    : {}
                }
              >
                <div className="form-item-supplier-label">Supplier Name:</div>
                <div className="form-item-input-supplier">
                  <Input
                    value={companyName}
                    onChange={handleInputChange}
                    className="rounded-sm bg-[#D9D9D933]"
                    data-testid="companyname"
                    autoFocus={true}
                    size="small"
                  />
                  {companyNameError && (
                    <div
                      className="error-message"
                      data-testid="company-name-error"
                    >
                      {companyNameError}
                    </div>
                  )}
                </div>
              </div>
            </Col>

            <Col span={12} xs={24} sm={24} md={12} lg={12} xl={12}>
              <div className="form-item-content-supplier">
                <div className="form-item-supplier-label">Supplier ID : </div>
                <div className="form-item-input-supplier">
                  <Input
                    value={supplierId}
                    type="text"
                    onChange={handleSupplierIdChange}
                    className="rounded-sm bg-[#D9D9D933]"
                    data-testid="supplierid"
                    size="small"
                  />
                </div>
              </div>
            </Col>

            <Col span={12} xs={24} sm={24} md={12} lg={12} xl={12}>
              <div className="form-item-content-supplier">
                <div className="form-item-supplier-label">Supplier Type : </div>
                <div className="form-item-input-supplier">
                  <Select
                    value={userType}
                    onChange={(value) => dispatch(setUserType(value))}
                    className="w-full rounded-sm border border-[#d9d9d9]"
                    data-testid="suppliertype"
                    size="small"
                  >
                    {supplierTypeOptions.map((type) => (
                      <Option key={type} value={type}>
                        {type}
                      </Option>
                    ))}
                  </Select>
                </div>
              </div>
            </Col>
            <Col span={12} xs={24} sm={24} md={12} lg={12} xl={12}>
              <div className="form-item-content-supplier">
                <div className="form-item-supplier-label">Country Code : </div>
                <div className="form-item-input-supplier">
                  <Select
                    showSearch
                    placeholder="Select a country"
                    value={countryCode}
                    onChange={(value) => dispatch(setCountryCode(value))}
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    options={countryOptions}
                    className="w-full rounded-sm border border-[#d9d9d9]"
                    data-testid="countrycode"
                    size="small"
                  />
                </div>
              </div>
            </Col>

            <Col span={12} xs={24} sm={24} md={12} lg={12} xl={12}>
              <div className="form-item-content-supplier">
                <div className="form-item-supplier-label">Reported : </div>
                <div className="form-item-input-supplier">
                  <Select
                    value={reported}
                    onChange={(value) => dispatch(setReported(value))}
                    className="w-full rounded-sm border border-[#d9d9d9]"
                    data-testid="reported"
                    size="small"
                  >
                    {reportedOptions.map((code) => (
                      <Option key={code} value={code}>
                        {code}
                      </Option>
                    ))}
                  </Select>
                </div>
              </div>
            </Col>

            <Col span={12} xs={24} sm={24} md={12} lg={12} xl={12}>
              <div className="form-item-content-supplier">
                <div className="form-item-supplier-label">Goals : </div>
                <div className="form-item-input-supplier">
                  <Select
                    value={goalsSubmitted}
                    onChange={(value) => dispatch(setGoalsSubmitted(value))}
                    className="w-full rounded-sm border border-[#d9d9d9]"
                    data-testid="goals"
                    size="small"
                  >
                    {goalsOption.map((code) => (
                      <Option key={code} value={code}>
                        {code}
                      </Option>
                    ))}
                  </Select>
                </div>
              </div>
            </Col>
          </Row>

          <Row justify="end" className="mt-4">
            <div className="form-item-button-supplier">
              <Button
                type="primary"
                onClick={handleCancelFilter}
                className="bg-[#FFFFFF] text-[#2C5778] border-[#2C57785C] mr-4 md:px-4"
                data-testid="cancel-filter-button"
                size="small"
              >
                Cancel
              </Button>
              <Button
                type="primary"
                onClick={handleApplyFilter}
                className="bg-[#2C5778] text-white md:px-4"
                data-testid="apply-filter-button"
                size="small"
              >
                Apply Filter
              </Button>
            </div>
          </Row>
        </Form>
      </div>

      {filteredData.length > 0 && (
        <>
          <div className="flex justify-end items-center">
            <Button
              type="primary"
              shape="round"
              icon={<DownloadOutlined />}
              onClick={handleDownloadExcel}
              size="60px"
              className="top-[3px] w-[175px] h-[43px] bg-[#1F405A]"
              disabled={excelDownloadButtonEnable}
            >
              {TEXT_CONSTANTS.DOWNLOAD_BUTTON}
            </Button>
          </div>
          <div className="styled-table-container">
            <Table
              dataSource={filteredData}
              columns={SUPPLIER_SEARCH_COLUMNS}
              pagination={{
                pageSize: 6,
                position: ["bottomCenter"],
              }}
              className="mt-6 styled-table"
              scroll={{ x: "100%", y: 400 }} 
              tableLayout="fixed" 
              data-testid="supplier-table"
            />
          </div>
        </>
      )}
    </>
  );
};
export default SupplierSearch;
